import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, apiError } from "../../lib/api";
import { LogoFull } from "../site/Logo";

const inp = "w-full border-b border-[#15202B]/30 bg-transparent py-3 outline-none focus:border-[#15202B]";
const card = "w-full max-w-sm bg-white p-8 sm:p-10 shadow-xl grid gap-5";

export const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState(""); const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false); const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (ex) { setErr(apiError(ex, "Envoi impossible.")); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className={card} data-testid="forgot-password-form">
      <LogoFull className="h-16 text-[#15202B] justify-self-start" />
      <h1 className="f-display text-4xl font-light">Mot de passe oublié</h1>
      {sent ? (
        <p className="text-sm text-[#24502C]" data-testid="forgot-password-sent">Si ce courriel correspond à l’espace artiste, un lien pour choisir un nouveau mot de passe vient d’y être envoyé. Il est valide 1 heure.</p>
      ) : (<>
        <p className="text-sm text-[#2E3B47]">Entrez votre courriel : vous recevrez un lien pour choisir un nouveau mot de passe.</p>
        <input className={inp} type="email" required placeholder="Courriel" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" aria-label="Courriel" />
        {err && <p className="text-sm text-[#A2372F]" data-testid="forgot-password-error">{err}</p>}
        <button className="btn-ink justify-center" disabled={busy} data-testid="forgot-password-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Recevoir le lien"}</button>
      </>)}
      <button type="button" onClick={onBack} className="text-sm text-[#3E6173] underline underline-offset-4 justify-self-start" data-testid="forgot-back-button">← Retour à la connexion</button>
    </form>
  );
};

export const ResetPassword = ({ token, onDone }) => {
  const [f, setF] = useState({ new: "", confirm: "" }); const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null); const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setMsg(null);
    if (f.new.length < 8) return setMsg("Le mot de passe doit contenir au moins 8 caractères.");
    if (f.new !== f.confirm) return setMsg("Les deux mots de passe ne sont pas identiques.");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new: f.new }); setOk(true); }
    catch (ex) { setMsg(apiError(ex)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className={card} data-testid="reset-password-form">
      <LogoFull className="h-16 text-[#15202B] justify-self-start" />
      <h1 className="f-display text-4xl font-light">Nouveau mot de passe</h1>
      {ok ? (
        <p className="text-sm text-[#24502C]" data-testid="reset-password-success">Mot de passe changé. Vous pouvez maintenant vous connecter.</p>
      ) : (<>
        <input className={inp} type="password" placeholder="Nouveau mot de passe (8 caractères min.)" autoComplete="new-password" value={f.new} onChange={(e) => setF({ ...f, new: e.target.value })} data-testid="reset-new-input" aria-label="Nouveau mot de passe" />
        <input className={inp} type="password" placeholder="Confirmer le mot de passe" autoComplete="new-password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="reset-confirm-input" aria-label="Confirmer le mot de passe" />
        {msg && <p className="text-sm text-[#A2372F]" data-testid="reset-password-error">{msg}</p>}
        <button className="btn-ink justify-center" disabled={busy} data-testid="reset-password-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enregistrer"}</button>
      </>)}
      <button type="button" onClick={onDone} className="text-sm text-[#3E6173] underline underline-offset-4 justify-self-start" data-testid="reset-to-login-button">Aller à la connexion</button>
    </form>
  );
};
